const UsersRoles = {
  user: 'user',
  superUser: 'superUser',
  admin: 'admin',
  agronomist: 'agronomist',
};

export default UsersRoles;



// WEBPACK FOOTER //
// ./src/infrastructure/UsersRoles.ts